<template>
  <div class="card" v-show="currentCardId == 'create-date'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>履歴書の作成日を入力</h2>
        <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form-list">
          <div class="create-date-action">
            <div class="action-item">
              <el-button
                class="button-block"
                :disabled="isTodaySelected"
                @click="setToday"
                >今日の日付を入力</el-button
              >
            </div>
            <div class="action-item">
              <el-button
                class="button-block"
                :disabled="isTomorrowSelected"
                @click="setTomorrow"
                >明日の日付を入力</el-button
              >
            </div>
            <div class="action-item">
              <el-date-picker
                v-model="formatData.createDate"
                type="date"
                :clearable="false"
                placeholder="選択してください"
                :format="'yyyy年M月d日'"
              />
            </div>
          </div>
        </div>
        <br />
        <div v-if="site.appFlag != 'b'">
          <el-collapse accordion v-model="activeName">
            <el-collapse-item name="1">
              <template #title>
                <div class="yagitaku">
                  <span class="yagitaku_recommend">超簡単！</span
                  >1クリックでメール提出！ヤギのメール便サービス
                </div>
              </template>
              <div class="el-collapse-item__content">
                <p>
                  メーラーの立ち上げ不要！履歴書を作ってそのままノンストップで就職または転職を考えている企業先に、メールで履歴書を送信できます
                </p>

                <div class="bnr_item create-date_bnr">
                  <div class="bnr_txt create-date_txt">
                    <el-button
                      style="
                        width: 100%;
                        border: 0;
                        padding: 0;
                        background: #eff8f8;
                      "
                      :disabled="!deviceLib.isOnline || !isSendYagiPostEnabled"
                      @click="onSendQuickEmail"
                    >
                      <h3>ヤギのメール便<span>をつかう</span></h3>
                    </el-button>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'

const props = defineProps<{
  currentCardId?: string
  formatId?: string
  isSendYagiPostEnabled: boolean
}>()

type DateFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}

const { formLib: formLibRaw, site, deviceLib } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & DateFormLib
const formatData = useNewRirekishoFormatData()
const activeName = ref('1')

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  formatData.createDate = formLib.getToday()
}

function setTomorrow() {
  formatData.createDate = formLib.getTommorow()
}

function onSendQuickEmail() {
  emitter.emit('send-special-quickemail', props.formatId)
}
</script>

<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #e3165c;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.create-date_bnr {
  margin: 15px 0;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_item {
  text-align: center;
}

.bnr_txt {
  padding: 15px;
  background: #eff8f8;
  border-radius: 0 0 10px 10px;
}

.bnr_txt h3 {
  color: #e3165c;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}
</style>
